import i18n from "@/i18n/index.js";

const meta = {
  pageName: i18n.t("historicalPlans.modelName"),
  pageIcon: "historicalPlans.svg",
  currentPage: "historical-plans",
  currentSubPage: "",
};

export default meta;
